//#region import icons
import ic_return from '../assets/icons/ic_return.svg'
import ic_email from '../assets/icons/ic_email.svg'
import ic_password from '../assets/icons/ic_password.svg'
import logo_ic from '../assets/icons/logo_ic.svg'
import logo1 from '../assets/icons/logo1.svg'
import logo2 from '../assets/icons/logo2.svg'
import logo_text from '../assets/icons/logo_text.svg'

import ic_search from '../assets/icons/ic_search.svg'
import ic_bolt_fill from '../assets/icons/ic_bolt_fill.svg'
import ic_bolt_outlinel from '../assets/icons/ic_bolt_outlinel.svg'
import ic_location from '../assets/icons/ic_location.svg'
import img_girl_with_books from '../assets/icons/img_girl_with_books.png'
import img_404 from '../assets/icons/img_404.png'

import ic_dots from '../assets/icons/ic_dots.svg'
import ic_profile from '../assets/icons/ic_profile.svg'
import ic_bill from '../assets/icons/ic_bill.svg'
import ic_message from '../assets/icons/ic_message.svg'
import ic_case from '../assets/icons/ic_case.svg'
import ic_exit from '../assets/icons/ic_exit.svg'
import ic_home from '../assets/icons/ic_home.svg'
import ic_arrow_right from '../assets/icons/ic_arrow_right.svg'
import ic_settings from '../assets/icons/ic_settings.svg'
import ic_star from '../assets/icons/ic_star.svg'
import ic_pen from '../assets/icons/ic_pen.svg'

import ic_plus from '../assets/icons/ic_plus.svg'
import ic_list from '../assets/icons/ic_list.svg'
import ic_fast_forward from '../assets/icons/ic_fast_forward.svg'

import ic_textsms from '../assets/icons/ic_textsms.svg'
import ic_library_books from '../assets/icons/ic_library_books.svg'
import ic_return_x2 from '../assets/icons/ic_return_x2.svg'

import ic_unfold_more from '../assets/icons/ic_unfold_more.svg'
import ic_unfold_less from '../assets/icons/ic_unfold_less.svg'

// import ic_ from '../assets/icons/ic_.svg'
//#endregion

// icons
export const icons = {
    ic_return,img_girl_with_books,img_404,ic_unfold_more,
    ic_unfold_less,
    ic_email,ic_textsms,
    ic_library_books,ic_return_x2,
    ic_password,
    ic_search,
    ic_bolt_fill,
    ic_bolt_outline:ic_bolt_outlinel,
    ic_location,
    logo1,
    logo2,ic_plus,
    ic_list,
    ic_fast_forward,
    logo_text,
    logo_ic,ic_dots ,ic_home ,ic_message ,ic_bill ,ic_exit ,ic_case,ic_arrow_right,
    ic_profile ,ic_pen ,ic_settings ,ic_star
}


//color palette
export const cols = {
    mainDark_black: "#212227",
    mainDark_1: "#181E36",
    mainDark_2: "#1F2C4F",
    mainDark_3: "#2C1754",

    main_blue: "#5A5DF6",
    main_purple: "#8E8CF5",

    mainLight_1: "#F7F4FE",
    mainLight_2: "#EFF2F8",
    mainLight_3: "#F3F7FA",
    mainLight_4: "#F7FDFF",

    red: "#FF6464",
    golden: "#FFD700",
    green: "#23C865",
    greenSwamp: "#61C15D",
    gray: "#A7BBC7",
}